export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const capitalizeAll = (string) => {
  return string.split(' ').map(word => capitalize(word)).join(' ');
};
